import React, { useEffect, useRef, useState } from "react";
import Loading from "../Modals/Loading";
import packedProductsService from "../Services/packedProductsService";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "react-icons/md";

const PackedProducts = () => {
  const [scannedItems, setScannedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    const getScannedItems = async () => {
      try {
        setLoading(true);
        const response = await packedProductsService.fetchAll();
        if (response && response.scanneditems) {
          setScannedItems(response.scanneditems);
        }
      } catch (error) {
        console.error("Error fetching scanned items:", error.message);
      } finally {
        setLoading(false);
      }
    };

    getScannedItems();
  }, []);

  // const handleViewClick = (barcode) => {
  //   const filteredItems = scannedItems.filter(
  //     (item) => item.barcode === barcode
  //   );
  //   if (filteredItems.length > 0) {
  //     navigate(`/packed/details/${barcode}`, { state: { filteredItems } });
  //   } else {
  //     alert("No details found for this barcode.");
  //   }
  // };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <div ref={topRef} />
      <h1 className="font-bold text-3xl text-secondary mb-4">
        Packed Products
      </h1>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="fixed bottom-10 right-10 flex flex-col gap-3 z-50">
            <button
              onClick={() =>
                topRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:-translate-y-1 transition-all duration-300 group"
              title="Scroll to Top"
            >
              <MdKeyboardDoubleArrowUp className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
            </button>
            <button
              onClick={() =>
                bottomRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:translate-y-1 transition-all duration-300 group"
              title="Scroll to Bottom"
            >
              <MdKeyboardDoubleArrowDown className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
            </button>
          </div>
          {/* Table */}
          {scannedItems && scannedItems.length > 0 ? (
            <div className="table-div">
              <table className="w-full">
                <thead className="border-y-2 text-center text-black text-[10px]">
                  <tr>
                    <th className="py-4 w-[4%]">Sr No.</th>
                    <th className="py-4 w-[10%]">Customer</th>
                    <th className="py-4 w-[10%]">Order Reference No.</th>
                    <th className="py-4 w-[10%]">Part No.</th>
                    <th className="py-4 w-[10%]">Name</th>
                    <th className="py-4 w-[6%]">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {scannedItems.map((value, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-200 text-center text-[11px]"
                    >
                      <td className="py-4 text-center font-bold text-blue-500">
                        {index + 1}.
                      </td>
                      <td className="py-4 text-center font-semibold">
                        {value.customer_company_name}
                      </td>
                      <td className="py-4 text-center">
                        {value.order_reference_no}
                      </td>
                      <td className="py-4 text-center">
                        {value.part_number === "" ? "-" : value.part_number}
                      </td>
                      <td className="py-4 text-center font-bold">
                        {value.order_title}
                      </td>
                      <td className="py-4 text-center font-bold">
                        {value.order_invoice_quantity}
                      </td>
                      {/* <td className="py-4 text-center text-[12px]">
                        <button onClick={() => handleViewClick(value.barcode)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 20"
                            strokeWidth="0.2"
                            stroke="black"
                            className="size-4"
                          >
                            <path
                              fill="currentColor"
                              d="M8 5.5A2.59 2.59 0 0 0 5.33 8A2.59 2.59 0 0 0 8 10.5A2.59 2.59 0 0 0 10.67 8A2.59 2.59 0 0 0 8 5.5m0 3.75A1.35 1.35 0 0 1 6.58 8A1.35 1.35 0 0 1 8 6.75A1.35 1.35 0 0 1 9.42 8A1.35 1.35 0 0 1 8 9.25"
                            ></path>
                            <path
                              fill="currentColor"
                              d="M8 2.5A8.11 8.11 0 0 0 0 8a8.11 8.11 0 0 0 8 5.5A8.11 8.11 0 0 0 16 8a8.11 8.11 0 0 0-8-5.5m5.4 7.5A6.91 6.91 0 0 1 8 12.25A6.91 6.91 0 0 1 2.6 10a7.2 7.2 0 0 1-1.27-2A7.2 7.2 0 0 1 2.6 6A6.91 6.91 0 0 1 8 3.75A6.91 6.91 0 0 1 13.4 6a7.2 7.2 0 0 1 1.27 2a7.2 7.2 0 0 1-1.27 2"
                            ></path>
                          </svg>
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}
        </div>
      )}
      <div ref={bottomRef} />
    </main>
  );
};

export default PackedProducts;
